import { IFeature } from 'mod/featureV2/interface';

export const blog: IFeature = {
    moduleId: 'blog',
    type: 'blog',
    title: 'blog',
    config: {
        width: 387,
        height: 217,
        column: 3,
        spaceBetweenColumns: 21,
    },
    list: [
        {
            picUrl: 'https://image.next.vivosun.com/asset/width-1460/picture/776284c8742b4807c4fc878b3a0647bf.jpg',
            title: 'Title Title Title Title Title Title Title Title Title Title Title Title Title Title',
            altText: '',
            linkUrl: '/vivosun-smart-grow-system-c14?_lf=shop_adBanner',
            target: '_blank',
        },
        {
            picUrl: 'https://image.next.vivosun.com/asset/width-1460/picture/c7c715e89da0afb04e6e832c7f8efe79.jpg',
            title: 'Title Title Title Title Title Title Title Title Title Title Title Title Title Title',
            altText: '',
            linkUrl: '/diy-pool?_lf=shop_adBanner',
        },
        {
            picUrl: 'https://image.next.vivosun.com/asset/width-1460/picture/776284c8742b4807c4fc878b3a0647bf.jpg',
            title: 'Title Title Title Title Title Title Title Title Title Title Title Title Title Title',
            altText: '',
            linkUrl: '/vivosun-smart-grow-system-c14?_lf=shop_adBanner',
        },
        {
            picUrl: 'https://image.next.vivosun.com/asset/width-1460/picture/776284c8742b4807c4fc878b3a0647bf.jpg',
            title: 'Title Title Title Title Title Title Title Title Title Title Title Title Title Title',
            altText: '',
            linkUrl: '/vivosun-smart-grow-system-c14?_lf=shop_adBanner',
        },
    ],
};